import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ResizingCroppingImagesComponent } from './resizing-cropping-images';
export { ResizingCroppingImagesComponent } from './resizing-cropping-images';
var LyResizingCroppingSmallImageModule = (function () {
    function LyResizingCroppingSmallImageModule() {
    }
    /**
     * @return {?}
     */
    LyResizingCroppingSmallImageModule.forRoot = function () {
        return {
            ngModule: LyResizingCroppingSmallImageModule,
        };
    };
    return LyResizingCroppingSmallImageModule;
}());
export { LyResizingCroppingSmallImageModule };
LyResizingCroppingSmallImageModule.decorators = [
    { type: NgModule, args: [{
                imports: [CommonModule, FormsModule],
                exports: [ResizingCroppingImagesComponent],
                declarations: [ResizingCroppingImagesComponent],
            },] },
];
/**
 * @nocollapse
 */
LyResizingCroppingSmallImageModule.ctorParameters = function () { return []; };
function LyResizingCroppingSmallImageModule_tsickle_Closure_declarations() {
    /** @type {?} */
    LyResizingCroppingSmallImageModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    LyResizingCroppingSmallImageModule.ctorParameters;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/resizing-cropping-images/index.js
// module id = 1362
// module chunks = 31